import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '@/components/usePageTitle';
import { SlackChannels } from '@/features/ops/SlackChannels';

export const Route = createFileRoute('/_staff/staff/slack')({ component: SlackPage });

function SlackPage() {
  const { t } = useTranslation('ops');
  usePageTitle(t('slack.title'));
  return <SlackChannels />;
}
